import Calendar from '../../Images/svgs/calender.svg'

const CalendarIcon = () => {
  return <img src={Calendar} />
}

export default CalendarIcon
